import { AccountSearchResponseSchema, CLIENT_LIFECYCLE_HEADERS, } from '@packages/types';
import { api } from '../client.js';
/**
 * Searches clients, matters and (when requested) invoices in one call. Sends the
 * lifecycle header so matter `status` comes back canonical (`ACTIVE` / `INACTIVE`)
 * and the backend does not log a legacy caller.
 */
export function searchAccount(accountId, params) {
    const qs = new URLSearchParams({ q: params.q });
    for (const kind of params.include ?? [])
        qs.append('include', kind);
    if (params.limit != null)
        qs.set('limit', String(params.limit));
    return api(`/accounts/${accountId}/search?${qs.toString()}`, AccountSearchResponseSchema, {
        headers: CLIENT_LIFECYCLE_HEADERS,
    });
}
